// extracted by mini-css-extract-plugin
module.exports = {"wrap":"index_wrap_22B_9","header":"index_header_2Tdkv","icon":"index_icon_3pbqE","title":"index_title_2W79u","content":"index_content_2pMfz"};